<template>
  <div :class="['collapsible-text', {'is-open': isOpen}]">
    <div class="collapsible-text-content" ref="textContent">
      <slot />
    </div>
    <div v-if="showToggleButton" class="collapsible-text-button" @click="toggle">
      <NewTranslation v-if="isOpen" path="collapsibleText.showLess"></NewTranslation>
      <NewTranslation v-else path="collapsibleText.showMore"></NewTranslation>
    </div>
  </div>
</template>

<script>
import NewTranslation from '@/components/i18n/NewTranslation';
export default {
  name: 'ShowMoreText',
  components: {
    NewTranslation
  },
  props: {
    initialIsOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      showToggleButton: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.showToggleButton = this.$refs.textContent.scrollHeight > 135;
      this.isOpen = this.initialIsOpen
    });
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped lang="scss">
.collapsible-text {
  position: relative;
  background-color: #fff;
  padding-bottom: 20px;
  
  &-content {
    max-height: 135px;
    overflow: hidden;
    &.is-open {
      max-height: none;
    }
  }

  &.is-open &-content {
    max-height: none;
  }

  &-button {
    position: absolute;
    background-color: #FFFFFFA1;
    bottom: 0px;
    width: 100%;
    padding-top: 20px;
    text-decoration: underline;
    color: #1DB2D1;
    cursor: pointer;
  }

  &.is-open &-button {
    padding-top: 0px;
  }
}
</style>
